import React from 'react';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

const OffresHeader = ({ searchTerm, onSearchTermChange, onCreateClick }) => {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', md: 'center' }}
      gap={3}
      mb={6}
    >
      <Box>
        <Typography
          variant="h3"
          fontWeight="800"
          color="#1B2559"
          letterSpacing="-1px"
        >
          Soins individuels
        </Typography>
        <Typography variant="body1" color="#A3AED0">
          Pilotez vos prestations professionnelles en temps réel.
        </Typography>
      </Box>

      {/* BARRE DE RECHERCHE ET BOUTON AJOUTER */}
      <Stack
        direction="row"
        gap={2}
        width={{ xs: '100%', md: 'auto' }}
        alignItems="center"
      >
        <TextField
          placeholder="Rechercher par titre, intervenant..."
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => onSearchTermChange(e.target.value)}
          sx={{
            width: { xs: '100%', md: '300px' },
            '& .MuiOutlinedInput-root': {
              borderRadius: '12px',
              backgroundColor: '#FFFFFF',
              '& fieldset': { border: '1px solid #E2EBF6' },
              '&:hover fieldset': { borderColor: '#4318FF' },
              '&.Mui-focused fieldset': {
                borderWidth: '2px',
                borderColor: '#4318FF',
              },
            },
          }}
        />

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onCreateClick}
          sx={{
            bgcolor: '#4318FF',
            borderRadius: '18px',
            px: 4,
            py: 1.8,
            fontWeight: '800',
            textTransform: 'none',
            fontSize: '1rem',
            whiteSpace: 'nowrap',
            boxShadow: '0px 10px 25px rgba(67, 24, 255, 0.3)',
          }}
        >
          Créer une consultation
        </Button>
      </Stack>
    </Stack>
  );
};

export default OffresHeader;
